import {
  ArrowPathIcon,
  ClockIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import Tooltip from '@onbeef/components/tooltip';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../stores/login';
import { LoyaltyDetailWelcoming } from './LoyaltyDetailWelcoming';
import { LoyaltyPointsHistory } from './PointsLoyaltyHistory';
import { useCartLoyaltyPoints } from '../hooks/useCartLoyaltyPoints';
export const PointsLoyaltyDetail = () => {
  const navigate = useNavigate();

  const user = useAuthStore((state) => state.user);

  const { handleRefreshLoyalty, isRefreshingLoyalty } = useCartLoyaltyPoints();

  const userLoyalty = user?.loyalty_programmes && user.loyalty_programmes[0];

  const userPoints = userLoyalty?.reward?.customer_points;
  const hasHistory = (userLoyalty?.reward?.customer_quantity_order || 0) > 0;

  const nextExpirationFormatted =
    userLoyalty?.reward.customer_points?.next_expiration_formatted;
  const pointsExpiredDays = userLoyalty?.reward?.points_expired_days_at;
  const pointsExpirationFormatted =
    pointsExpiredDays &&
    `Os pontos expiram em ${pointsExpiredDays} dia${
      pointsExpiredDays > 1 ? 's' : ''
    }`;

  const pendingPoints = userPoints?.pending || 0;

  return (
    <>
      {(userPoints &&
        (userPoints.available > 0 ||
          userPoints?.pending > 0 ||
          userPoints?.spent > 0)) ||
      hasHistory ? (
        <div className="flex flex-col bg-gray-100 rounded-t-3xl p-5 gap-5">
          <div className="flex items-start gap-3 bg-white p-2 rounded-lg">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                <span className="text-xl">👋</span>
              </div>
              <div>
                <h2 className="text-lg font-medium">
                  Olá, {user?.name || 'Cliente'}!
                </h2>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2 bg-white rounded-lg">
            <div className="border-b border-gray-200 p-5">
              <h3 className="text-lg font-semibold text-gray-800 mb-3">
                Seu saldo
              </h3>

              <div className="flex items-center justify-between bg-primary/5 p-3 rounded-lg">
                <div>
                  <p className="text-sm text-gray-500">Pontos disponíveis</p>
                  <p className="text-3xl font-bold text-primary">
                    {userPoints?.available || 0}
                  </p>
                </div>
                <button
                  className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center transition-all duration-300 hover:bg-primary/20"
                  type="button"
                  onClick={handleRefreshLoyalty}
                >
                  <ArrowPathIcon
                    className={`h-8 w-8 text-primary ${
                      isRefreshingLoyalty ? 'animate-spin' : ''
                    }`}
                  />
                </button>
              </div>

              <div className="flex items-center gap-2 text-sm text-gray-500 mt-3 font-medium">
                <ClockIcon className="w-5 h-5 flex-shrink-0" />
                <span className="line-clamp-1">
                  Você tem {pendingPoints} ponto{pendingPoints !== 1 ? 's' : ''}{' '}
                  pendente{pendingPoints !== 1 ? 's' : ''}
                </span>
                <Tooltip text="Os pontos ficam disponíveis após 24h e com o pedido entregue.">
                  <InformationCircleIcon className="w-5 h-5 flex-shrink-0" />
                </Tooltip>
              </div>

              {pointsExpirationFormatted && (
                <div className="w-full flex items-center gap-2 text-sm text-gray-500 mt-3 text-red-400 font-medium">
                  <ExclamationTriangleIcon className="w-5 h-5 flex-shrink-0" />
                  <Tooltip text={pointsExpirationFormatted}>
                    <span className="line-clamp-2">
                      {nextExpirationFormatted
                        ? nextExpirationFormatted
                        : pointsExpirationFormatted}
                    </span>
                  </Tooltip>
                </div>
              )}
            </div>

            <div className="border-b border-gray-200 p-5">
              <button
                className="w-full bg-primary text-white px-4 py-3 rounded-lg font-medium"
                type="button"
                onClick={() => navigate('/loyalty/rewards')}
              >
                Resgatar prêmios
              </button>
            </div>

            <LoyaltyPointsHistory />
          </div>
        </div>
      ) : (
        <LoyaltyDetailWelcoming />
      )}
    </>
  );
};
